/* global Highcharts */
(function () {
  'use strict';

  var id = 'bar-chart';
  var barChartMeasures = null;

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').factory(id + '.Utils', ['CardQueryResource', 'QueryES', id + '.Builder', function (CardQueryResource, QueryES, BarChartBuilder) {
    return {
      fetchData: function fetchData(cfg) {
        cfg = cfg || {};
        return CardQueryResource.getWithProgress("/bar-chart/data", cfg.cardId, cfg.params, cfg.cardToPreview, 'bar-chart-' + cfg.cardId);
      },
      getStatementDownloadUrl: function getStatementDownloadUrl(cardId) {
        return QueryES.queryExportUrl(cardId, true, id);
      },
      getBarChart: function getBarChart(data, config, compactLabels) {
        return BarChartBuilder.getHighChartsBuilder({
          data: data,
          config: config,
          compactLabels: compactLabels
        }).buildChart().getChart();
      }
    };
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.
    //route format MUST be: card.template.name + "/" + card.id
    when('/bar/:cardId', {
      templateUrl: 'modules/app/bar-chart/bar-chart-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/bar/:cardId/top', {
      templateUrl: 'modules/app/bar-chart/bar-chart-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "bar": "bar"
    });
  }]).controller(id + ".CardConfiguration", ['$controller', '$rootScope', '$scope', function ($controller, $rootScope, $scope) {
    $scope.tempMeasures = barChartMeasures;
    $scope.templateType = "bar";
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });

    // Bar charts only allow one dimension
    if ($scope.workingConfig && $scope.workingConfig.dimensions && $scope.workingConfig.dimensions.length > 1) {
      $scope.workingConfig.dimensions = [$scope.workingConfig.dimensions[0]];
    }
    $scope.barchartHelpText = {
      helpTitle: 'Bar ',
      detailText: "In the Bar section, you'll choose how you want to group data (in the Organized " + "menu) and what measures you'll want to see (using the Measures menu). Choose an option in the " + "Organized menu first, and then select as many measures as you'd like by choosing them in the " + "dropdown and clicking Add Measure. Remove a measure by clicking the X next to a selected measure. " + "The Orientation option allows you to choose whether you want your Bar report to represent " + "data horizontally or vertically. The Charts option allows you to choose whether you want all of " + "your measures to display on the same chart or whether you want different charts for each measure."
    };

    // Overriding this function because it needs to send 'bar' as chartType to sortDirective()
    $scope.sortSelected = function () {
      $scope.workingConfig.defaultSort = $scope.sortConfig.sortDirective('bar');
      $scope.updateCardWithWorkingConfig();
    };
    $scope.$watch("workingConfig.vertical", _.debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    var addTotalToSortOptions = function addTotalToSortOptions() {
      var includeTotal = $scope.workingConfig.stacking === "normal" && $scope.workingConfig.singleGraph && $scope.measures.length > 1;
      var totalIsPresent = $scope.sortConfig.options[$scope.sortConfig.options.length - 1].value === "sum";

      //this is triggered multiple times from different watchers so we have to check if the total option is already there
      if (includeTotal && !totalIsPresent) {
        $scope.sortConfig.options.push({
          name: "-Total",
          value: 'sum'
        });
      } else if (!includeTotal && totalIsPresent) {
        // Change the selection from total if it was selected before removing it
        if ($scope.sortConfig.index === $scope.sortConfig.options.length - 1) {
          $scope.sortConfig.setSelections('-measure[0].value');
          $scope.workingConfig.defaultSort = $scope.sortConfig.sortDirective('bar');
        }
        $scope.sortConfig.options.splice(-1, 1);
      }
    };
    $scope.$watch("workingConfig.singleGraph", _.debounce(function () {
      $scope.sortConfig.setOptions($scope.selectedDimension, $scope.measures, $scope.workingConfig.singleGraph);
      addTotalToSortOptions();
      $scope.workingConfig.defaultSort = $scope.workingConfig.defaultSort || $scope.sortConfig.sortDirective();
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    $scope.$watch("workingConfig.stacking", _.debounce(function () {
      addTotalToSortOptions();
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    $scope.$watch("workingConfig.showDataLabels", _.debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    $scope.$watch("measures.length", _.debounce(function () {
      addTotalToSortOptions();
      $scope.updateCardWithWorkingConfig();
    }, 100), true);

    //clear out any bar-chartMeasures on a new explore card event
    $rootScope.$on('explore-card', function () {
      barChartMeasures = null;
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', 'AggregationUtils', 'wsEventNames', '$routeParams', 'CardDisplay', 'ReportValidationService', function ($scope, CardRegistry, Utils, AggUtils, wsEvents, $routeParams, CardDisplay, ReportValidationService) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.measures = $scope.config.measures;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    if (!$scope.config.hiddenMeasures) {
      $scope.config.hiddenMeasures = [];
    }
    $scope.defaultSummary = 'Bar chart of measures organized by ' + AggUtils.getDimensionInSentence($scope.config.dimensions[0], true) + '.';
    $scope.getMeasureValueDisplay = AggUtils.getMeasureValueDisplay;
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardToPreview,
      params: {
        "_limit": CardDisplay.getLimitParam($scope.cardId) || ($scope.measures.length > 1 ? Math.floor(20 / $scope.measures.length) : 15),
        "_offset": 0,
        "order_by": $scope.config.defaultSort || '-measure[0].value'
      }
    };
    Utils.fetchData(fetchCfg).then(function (r) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, r);
      }
      var data = r.results[0].result.data;
      var compactLabels = $scope.showCompactLabels || false;
      $scope.averages = r.results[0].result.stats;
      $scope.barChart = Utils.getBarChart(data, $scope.config, compactLabels);
      $scope.hasData = data.length > 0 && $scope.measures.length > 0;
    }, function () {
      $scope.hasData = false;
    });
  }]).controller(id + ".Detail", ["$scope", "$routeParams", "$timeout", "CardRegistry", "CardUtils", 'ReportValidationService', id + '.Utils', 'AggregationUtils', 'wsEventNames', "CardQueryResource", '$sanitize', 'ChartUtils', 'ReportLinks', function ($scope, $routeParams, $timeout, CardRegistry, CardUtils, ReportValidationService, Utils, AggUtils, wsEventNames, CardQueryResource, $sanitize, ChartUtils, ReportLinks) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    if (!$scope.config.hiddenMeasures) {
      $scope.config.hiddenMeasures = [];
    }
    $scope.measures = $scope.config.measures;
    $scope.dimension = {
      name: AggUtils.getDimensionInSentence($scope.config.dimensions[0])
    };
    var sortConfigOptions = {
      dimension: $scope.dimension,
      measures: $scope.config.measures,
      defaultSort: $scope.config.defaultSort
    };
    $scope.sortConfig = AggUtils.sortConfig(sortConfigOptions); // For the sorting dropdowns

    $scope.sortConfig.setSelections($scope.config.defaultSort || $scope.sortConfig.defaultSort);
    $scope.hideMeasures = AggUtils.hideMeasures($scope.config);
    function getSingleMeasureChart(pageData, mi) {
      //create temp config with only 1 measure
      var tempConfig = angular.copy($scope.config);
      tempConfig.measures = [tempConfig.measures[mi]];

      //create temp data with only 1 measure
      var tempData = _.map(angular.copy(pageData), function (d) {
        d.aggregations = [d.aggregations[mi]];
        return d;
      });
      var chart = Utils.getBarChart(tempData, tempConfig);

      //make sure the series colors match the top level card
      chart.series[0].color = ChartUtils.getSeriesColor($scope.config, mi, Highcharts.getOptions().colors[mi]);

      //clean axis and text
      _.each(chart.yAxis, function (a) {
        a.opposite = !$scope.config.vertical;
      });
      chart.title.text = $sanitize(tempConfig.measures[0].name);
      chart.title.align = "center";
      ReportLinks.BarCharts.registerObservers(chart, [ReportLinks.BarCharts.makeEventObserver('plotOptions.series.point', ['mouseOver', 'mouseOut']), ReportLinks.BarCharts.makeEventObserver('plotOptions.bar', ['click']), ReportLinks.BarCharts.makeEventObserver('plotOptions.column', ['click'])], {
        config: $scope.config
      });
      return chart;
    }
    function createAllCharts(pageData) {
      if (!$scope.config.vertical) {
        var barsPerDimension = $scope.config.singleGraph && !$scope.config.stacking ? $scope.config.measures.length : 1,
          barsHeight = 20 * barsPerDimension * pageData.length;

        // Added 60px to below base heights to account for (long) slanted axis labels
        $scope.chartHeight = barsHeight + ($scope.config.singleGraph ? 160 : 220) + 'px';
      }
      if (!$scope.config.singleGraph) {
        //create a separate chart for each measure
        $scope.barCharts = [];
        _.chain($scope.config.measures).filter(function (m, i) {
          return $scope.config.hiddenMeasures.indexOf(i) === -1;
        }).each(function (m, mi) {
          var chart = getSingleMeasureChart(pageData, mi);
          $scope.barCharts.push(chart);
        });
      } else {
        $scope.barCharts = [Utils.getBarChart(pageData, $scope.config)];
      }
    }
    $scope.sort = function (option, direction) {
      $scope.sortConfig.option = option;
      $scope.sortConfig.direction = direction;
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    };
    $scope.fetchPage = function (offset, limit) {
      offset = offset || 0;
      limit = limit || 10;
      var fetchCfg = {
        cardId: $scope.card.id,
        cardToPreview: $scope.card.id === 'preview' ? $scope.card : null,
        params: {
          "_limit": limit,
          "_offset": offset,
          "order_by": $scope.sortConfig.sortDirective('bar')
        }
      };
      return Utils.fetchData(fetchCfg).then(function (data) {
        var results = data.results[0].result;
        $scope.hasData = results.data.length > 0;
        $scope.pagenote.setReportMetadata(data);
        $scope.stats = results.stats;
        $scope.pageData = results.data;

        // Sad, but due to a very odd timing issue, this has to be in
        // a very slightly delayed $timeout call
        $timeout(getCharts.bind(this, $scope.pageData), 10);
        return results;
      }, function () {
        $scope.hasData = false;
      });
    };
    function getCharts(data) {
      // hide empty rows should always be across all measures. That way, when multiple
      // charts are displayed, the bars remain properly aligned with each other.
      if ($scope.hideNullValues) {
        // filter rows, keeping only rows for which at least one measure is defined
        data = _.filter(data, function (d) {
          return _.any(d.aggregations, function (a) {
            return !_.isUndefined(a.value);
          });
        });
      } else {
        // If there are no null value anyhow, don't even show the "hide null values" option
        var nullDataRows = _.filter(data, function (d) {
          return _.any(d.aggregations, function (a) {
            return _.isUndefined(a.value);
          });
        });
        if (nullDataRows.length > 0) {
          $scope.showHideNullRowCheckbox = true;
        }
      }
      createAllCharts(data);
    }
    $scope.hideNullValues = false;
    $scope.hideNullValuesChecked = function () {
      $scope.hideNullValues = !$scope.hideNullValues;
      getCharts($scope.pageData);
    };
    CardUtils.setNavElements($scope, $scope.cardId, $scope.cardId);
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('bar-chart/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config : $scope.cardId)
    }];
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
    $timeout(function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    }, 0);
  }]);
})();
